<template>
  <div class="ccpitPage project_detail">
    <mt-header title="展馆规划">
      <span slot="left" @click="()=>this.$router.back()">
        <i class="iconfont icon-left"></i>
        Return
      </span>
    </mt-header>
    <div class="detailsContent1">
      <div>
        <img src="http://www.cippe.com.cn/miniprogram/duijiehui.jpg" alt=""/>
      </div>
    </div>
    
  </div>
</template>

<script>
import { Header } from 'mint-ui';
import "mint-ui/lib/header/style.css"
export default {
  components:{
    'mt-header':Header,
  },
  data () {
    return {
     
    }
  }

}
</script>

<style scoped>
  .ccpitPage{
    /* padding:0 20px; */
    height: 100%;
    background-color: white;
  }
  .mint-header{
    /* margin-left: -20px;
    margin-right: -20px; */
    height: 40px;
    background-color: #008baf;
    position: relative;
    z-index: 10;
  }
  .detailsContent1{
    height: calc(100% - 40px);
    overflow-y: auto;
    /* padding: 0 20px; */
  }
</style>